import { render, staticRenderFns } from "./exchangeRecord.vue?vue&type=template&id=6ee77428&scoped=true"
import script from "./exchangeRecord.vue?vue&type=script&lang=js"
export * from "./exchangeRecord.vue?vue&type=script&lang=js"
import style0 from "./exchangeRecord.vue?vue&type=style&index=0&id=6ee77428&prod&lang=less"
import style1 from "./exchangeRecord.vue?vue&type=style&index=1&id=6ee77428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee77428",
  null
  
)

export default component.exports